import React from "react";
import { headerCells } from "./headerCells";
import {
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { BLACK } from "../../../../constants";

interface AdhocAgreementsTableHeaderProps {
  handleSortRows: (property: string) => void;
  sortBy: string;
  sortDirection: string;
}

const useStyles = makeStyles(() => ({
  headerCell: {
    fontWeight: "bold",
    textTransform: "uppercase",
    letterSpacing: "2px"
  },
  tableCell: {
    border: "none",
    minWidth: "200px"
  },
  tableHeader: {
    backgroundColor: BLACK,
    border: "none"
  },
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1
  }
}));

export const AdhocAgreementsTableHeader: React.FC<AdhocAgreementsTableHeaderProps> = ({
  handleSortRows,
  sortBy,
  sortDirection
}) => {
  const classes = useStyles();
  const createSortHandler = (property: string) => () => {
    handleSortRows(property);
  };
  return (
    <TableHead className={classes.tableHeader}>
      <TableRow>
        {headerCells.map(headerCell => (
          <TableCell
            key={headerCell.id}
            className={classes.tableCell}
            align={"left"}
          >
            <TableSortLabel
              active={sortBy === headerCell.id}
              direction={"asc"}
              onClick={createSortHandler(headerCell.id)}
            >
              <span className={classes.headerCell}>{headerCell.label}</span>
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

export default AdhocAgreementsTableHeader;
